export const paginationState = () => ({
  currentPage: null,
  totalPages: null,
  totalCount: null,
  limit: null,
  pages: {}
});

export const resetPaginationState = pagination => ({
  ...pagination,
  pages: {},
  currentPage: 1
});
